import { BaseService } from '../base';

export type InsurerCompany = {
  id: number;
  name: string;
  cpfCnpj: string;
};

export type InsurerCompaniesResponse = InsurerCompany[];

export class InsurerCompaniesService extends BaseService {
  async list(): Promise<{
    success: boolean;
    data?: InsurerCompaniesResponse;
    error?: string;
  }> {
    try {
      const response = await this.get(
        '/portal/v1/services/insurer-companies',
        {},
        import.meta.env.VITE_API_URL,
      );
      return await this.handleJsonResponse<InsurerCompaniesResponse>(response);
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao carregar congêneres',
      };
    }
  }
}

export const insurerCompaniesService = new InsurerCompaniesService();
